import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "onChange", "maskOptions", "unmask"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef, useCallback, useEffect } from 'react';
import { combineRefs } from '@carnica/utils';
import { useIMask } from 'react-imask';
import { setCaretPosition } from "./utils";
export var withMaskedInput = function withMaskedInput(mask) {
  var inputMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'tel';
  var params = arguments.length > 2 ? arguments[2] : undefined;
  return function (Component) {
    return /*#__PURE__*/forwardRef(function (props, ref) {
      var value = props.value,
        onChange = props.onChange,
        _props$maskOptions = props.maskOptions,
        maskOptions = _props$maskOptions === void 0 ? {} : _props$maskOptions,
        _props$unmask = props.unmask,
        unmask = _props$unmask === void 0 ? true : _props$unmask,
        otherProps = _objectWithoutProperties(props, _excluded);
      var _ref = params || {},
        _onAccept = _ref.onAccept,
        onComplete = _ref.onComplete;
      var inputMask = useIMask(_objectSpread(_objectSpread({}, typeof mask === 'string' ? {
        mask: mask
      } : mask), maskOptions), {
        onAccept: function onAccept(newValue, imask, e) {
          var _ref2 = imask.el,
            input = _ref2.input;
          onChange === null || onChange === void 0 ? void 0 : onChange(unmask ? imask.unmaskedValue : newValue, e);
          _onAccept === null || _onAccept === void 0 ? void 0 : _onAccept(newValue, imask, e);
          input.dataset.maskedValue = newValue;
          input.dataset.unmaskedValue = imask.unmaskedValue;
        },
        onComplete: onComplete
      });
      useEffect(function () {
        if (!inputMask.maskRef.current) {
          return;
        }
        if (typeof value === 'string' && inputMask.maskRef.current.value !== value) {
          inputMask.maskRef.current.value = value;
          inputMask.maskRef.current.updateValue();
        }
      }, [value]);
      var handleFocus = useCallback(function (e) {
        var _onFocus, _ref3;
        var position = inputMask.value.length || 0;
        setCaretPosition(inputMask.ref, position);
        (_onFocus = (_ref3 = otherProps).onFocus) === null || _onFocus === void 0 ? void 0 : _onFocus.call(_ref3, unmask ? inputMask.unmaskedValue : inputMask.value, e);
      }, [inputMask.value, inputMask.unmaskedValue, unmask]);
      var Input = Component;
      return /*#__PURE__*/React.createElement(Input, _extends({}, otherProps, {
        "data-value": value,
        inputMode: inputMode,
        onFocus: handleFocus,
        ref: combineRefs([ref, inputMask.ref]),
        "data-t-id": "hocs-withMaskedInput"
      }));
    });
  };
};